"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersionPipe = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
let VersionPipe = class VersionPipe {
    transform(value, currentVersion) {
        if (value) {
            if (currentVersion) {
                return value.filter(item => {
                    let minVersion = JSON.parse(JSON.stringify(item.minVersion)) || "0.0.1";
                    let maxVersion = JSON.parse(JSON.stringify(item.maxVersion)) || "100000.100000.100000";
                    let min = minVersion.split(".").map(value => parseInt(value));
                    let cur = currentVersion.split(".").map(value => parseInt(value));
                    let max = maxVersion.split(".").map(value => parseInt(value));
                    function mincompare(index) {
                        if (index > 2)
                            return true;
                        if (cur[index] > min[index])
                            return true;
                        else if (cur[index] < min[index])
                            return false;
                        else
                            return mincompare(++index);
                    }
                    function maxcompare(index) {
                        if (index > 2)
                            return true;
                        if (cur[index] < max[index])
                            return true;
                        else if (cur[index] > max[index])
                            return false;
                        else
                            return maxcompare(++index);
                    }
                    return mincompare(0) && maxcompare(0);
                });
            }
        }
    }
};
exports.VersionPipe = VersionPipe;
exports.VersionPipe = VersionPipe = __decorate([
    (0, core_1.Pipe)({ name: 'version', pure: false })
], VersionPipe);
//# sourceMappingURL=version.pipe.js.map